module.exports = __webpack_public_path__ + "img/july4.e77a6053.jpg";